import thumb from "../../assets/images/all-img/service/thumb.png";
export default function InovativeServiceSection() {
	return (
		<div className="fugu-innovative-services-section">
			<div className="container">
				<div className="row">
					<div className="col-xxl-6 col-xl-6 col-lg-6 offset-xxl-1 order-lg-2">
						<div className="fugu-innovative-services-thumb wow fadeInUpX">
							<img src={thumb} alt="" />
						</div>
					</div>
					<div className="col-xxl-5 col-xl-6 col-lg-6 col-md-10 d-flex align-items-center">
						<div className="fugu-default-content">
							<h2>We provide all kinds of innovative services as per your needs</h2>
							<p>
								We have been providing services for a long time. We’re caring about customers & provide
								all necessary services. We always vigilant to maintain the quality of service.
							</p>
							<p>
								We are serving with honor in many countries of the world, you can take our services with
								sincerity.
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
